module.exports = __webpack_public_path__ + "img/arrow.4e187d12.svg";